import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Analytics = Loadable(lazy(() => import('./BusBooking')));
const BusList = Loadable(lazy(() => import('./BusList')));
// const EditPipeline = Loadable(lazy(() => import('./CustomerEdit')));
// const Trans = Loadable(lazy(() => import('./CustomerTransList')));

const BusRoutes = [
	{
		path: '/bus/bookings',
		element: <Analytics />,
		auth: authRoles.admin,
	},
	{
		path: '/bus/list',
		element: <BusList />,
		auth: authRoles.admin,
	},
	// {
	// 	path: '/customer/list/trans',
	// 	element: <Trans />,
	// 	auth: authRoles.admin,
	// },
	// {
	// 	path: '/customer/list/edit',
	// 	element: <EditPipeline />,
	// 	auth: authRoles.admin,
	// },
];

export default BusRoutes;
